import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FooterComponent } from '@components/footer/footer.component';

@NgModule({
  imports: [
    CommonModule,
    IonicModule
  ],
  declarations: [FooterComponent],
  exports: [FooterComponent]
})

export class FooterModule {}
